import { Add, GridView } from "@mui/icons-material";
import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";
import ModalContainer from "../../Components/Modal/ModalContainer";
import { ButtonTable } from "../../Layouts/ButtonsControlled";
import CreateUtility from "../UtilityProviders/CreateUtility";

const Contractors = () => {
    const location = useLocation();
    const path = location.pathname.split("/")[2];

    return (
        <>
            <ModalContainer>
                <CreateUtility />
            </ModalContainer>
            <HeaderTable>
                <div className="title">
                    <GridView />
                    <span> {path} </span>
                </div>
                <Link to="/dashboard/contractors/create">
                    <ButtonTable startIcon={<Add />}>New</ButtonTable>
                </Link>
            </HeaderTable>
            <Outlet />
        </>
    );
};

export default Contractors;
